import React, { useContext, useState, useRef } from "react";
import Drawer from "@mui/material/Drawer";
import CloseImg from "../../Images/CloseImg.png";
import { AppContext } from "../../AppContext";
import ArrowDown from "../../Images/ArrowDown.png";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import LottifileLoading from "../../LottifileLoading.json";
import Lottie from "lottie-react";
import { useAppContext } from "../../AppContext";

const BootstrapDialogBuyNotLogin = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1024
        ? "90%"
        : window.innerWidth <= 1920
        ? "40%"
        : window.innerWidth <= 2560
        ? "50%"
        : window.innerWidth <= 3840
        ? "50%"
        : "40%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));
export default function AllCategoriesOpenMobileDrawer({}) {
  const [LoadingClickBuyButton, setLoadingClickBuyButton] = useState(false);

  const { t, i18n } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));

  const {
    MobileOpenDrawerOBJ,
    handleChildFunction1,
    OpenMobileDrawer,
    CloseMobileDrawerFromChildFunc,
    CreateProduct4,
    setLoadingClickBuyButtonAllApp,
    LoadingClickBuyButtonAllApp,
  } = useContext(AppContext);

  const [ChoosingProduct, setChoosingProduct] = React.useState(
    MobileOpenDrawerOBJ?.find((product) => product.id === product.productId)
  );
  React.useEffect(() => {
    const foundProduct = MobileOpenDrawerOBJ?.find(
      (product) => product.id === product.productId
    );
    setChoosingProduct(foundProduct);
  }, [MobileOpenDrawerOBJ, MobileOpenDrawerOBJ?.productId]); // Re-run effect when these dependencies change

  const CloseMobileDrawerFunc = () => {
    // const OBJ = { name: "mohammed" };
    // handleChildFunction1(OBJ);
    CloseMobileDrawerFromChildFunc();
  };

  const [selectedOption, setSelectedOption] = useState(""); // Default selected option

  const calculateTotalPrice = (price, amount, discount, discountOnEvery) => {
    let total = 0;

    for (let i = 1; i <= amount; i++) {
      if (i % discountOnEvery === 0) {
        // Apply discount to every 'discountOnEvery' item
        total += price * (1 - discount / 100);
      } else {
        // Add full price for non-discounted items
        total += price;
      }
    }

    // Format the total to show decimals only when needed
    const formattedTotal = Number.isInteger(total)
      ? total.toString()
      : parseFloat(total.toFixed(2));

    return formattedTotal;
  };

  const aa = useContext(AppContext);
  const BuyButton = (productId) => {
    console.log(aa);

    //    setLoadingClickBuyButtonAllApp(true);
    CreateProduct4(productId);
  };

  const [BuyNotLogin, setBuyNotLogin] = useState(false);
  const CloseModalBuyNotLogin = () => {
    setBuyNotLogin(false);
  };
  const ModalBuyNotLogin = () => {
    return (
      <div>
        <React.Fragment>
          <BootstrapDialogBuyNotLogin
            onClose={CloseModalBuyNotLogin}
            aria-labelledby="customized-dialog-title"
            open={BuyNotLogin}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <img
                src={CloseImg}
                alt="logo"
                style={{
                  minWidth: "30px", // Adjust the size
                  height: "30px", // Adjust the size
                  //borderRadius: "50%", // Makes the image circular
                  //paddingLeft: 200,
                  marginRight: 10,
                  marginTop: 10,
                  cursor: "pointer",
                }}
                onClick={() => {
                  setBuyNotLogin(false);
                }}
              />
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "calc(50vh - 55px)",
                  padding: 20,
                  //backgroundColor: "red",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <a>{t("profile.Pleaseloginfirsttopurchasethisproduct")}</a>
                <button
                  style={{
                    marginTop: 20,
                    backgroundColor: "#27272a",
                    color: "#fff",
                    border: "none",
                    //padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                    marginTop: 40,
                  }}
                  onClick={() => {
                    setBuyNotLogin(false);
                  }}
                >
                  <a style={{ fontSize: 14 }}>{t("profile.Ok")}</a>
                </button>
              </div>
            </div>
          </BootstrapDialogBuyNotLogin>
        </React.Fragment>
      </div>
    );
  };
  return (
    <div
      style={{
        fontFamily: "Droid Arabic Kufi, sans-serif",
      }}
    >
      {ModalBuyNotLogin()}
      <Drawer
        open={OpenMobileDrawer}
        onClose={CloseMobileDrawerFunc}
        anchor="bottom"
        PaperProps={{
          style: {
            height: "auto", // Height adjusts to content
            maxHeight: "90vh", // Optional: Limit max height
            overflow: "auto", // Enable scrolling
            padding: "16px",
          },
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            //justifyContent: "flex-end",
            paddingTop: 20,
            paddingBottom: 30,
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              marginLeft: "2%",
              marginRight: "2%",
              paddingBottom: 20,
            }}
          >
            <img
              onClick={() => {
                CloseMobileDrawerFunc();
              }}
              src={CloseImg}
              alt={"Expand"}
              style={{
                width: 25,
                height: 25,
                cursor: "pointer",
              }}
            />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              backgroundColor: "#fafafa",
            }}
          >
            <img
              src={ChoosingProduct?.image} // Replace with your image URL
              alt="Placeholder"
              style={{
                width: "100%",
                height: "100%",
                maxHeight: 200,
                maxWidth: 200,
                objectFit: "cover",
                //borderRadius: "8px",
                cursor: "pointer",
              }}
              onClick={() => {}}
            />
          </div>
          <a>{ChoosingProduct?.name}</a>
          <a>{ChoosingProduct?.productType}</a>
          {/* <a>
            {calculateTotalPrice(
              ChoosingProduct?.price,
              1,
              ChoosingProduct?.discount,
              1
            )}
          </a> */}
          <div
            style={{
              //height: "20%",
              width: "100%",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <p style={{ margin: 0 }}>
              <a
                style={{
                  fontSize: 15,
                }}
              >
                {ChoosingProduct?.discount === 0 ? (
                  <></>
                ) : (
                  <>
                    {ChoosingProduct?.theDeal === 1 ? (
                      <>
                        <a
                          style={{
                            backgroundColor: "#6b21a8",
                            color: "white",
                            margin: 0,
                            marginBottom: 5,

                            fontSize: 15,
                          }}
                        >
                          -{ChoosingProduct?.discount}%
                        </a>
                        <a
                          style={{
                            fontSize: 12,
                          }}
                        >
                          &nbsp;
                        </a>
                      </>
                    ) : (
                      <>
                        <a
                          style={{
                            backgroundColor: "#6b21a8",
                            color: "white",
                            fontSize: 12,
                          }}
                        >
                          Buy 2 pcs to get -{ChoosingProduct?.discount}% off
                          every {ChoosingProduct?.theDeal}
                          {ChoosingProduct?.theDeal === 2 ? "nd" : "th"} item
                        </a>
                      </>
                    )}
                  </>
                )}
              </a>
            </p>
            {ChoosingProduct?.discount === 0 ? (
              <></>
            ) : (
              <>
                &nbsp; &nbsp;
                {ChoosingProduct?.theDeal === 1 ? (
                  <p
                    style={{
                      margin: 0,
                      color:
                        ChoosingProduct?.discount === 0 ||
                        ChoosingProduct?.theDeal === 2
                          ? ""
                          : "red",
                    }}
                  >
                    {calculateTotalPrice(
                      ChoosingProduct?.price,
                      1,
                      ChoosingProduct?.discount,
                      1
                    )}
                    &nbsp; &nbsp;
                  </p>
                ) : (
                  <></>
                )}
              </>
            )}
            <a
              style={{
                textDecoration:
                  ChoosingProduct?.discount === 0 ||
                  ChoosingProduct?.theDeal === 2
                    ? "none"
                    : "line-through",
                fontSize: 15,
              }}
            >
              {ChoosingProduct?.priceInsteadOf === 0 ? (
                <>₪{ChoosingProduct?.price}</>
              ) : (
                <>
                  <>
                    <a
                      style={{
                        margin: 0,
                        color: "red",
                        textDecoration: "line-through",
                        fontSize: 15,
                      }}
                    >
                      ₪{ChoosingProduct?.price}
                    </a>
                    &nbsp;&nbsp;
                    <a
                      style={{
                        fontSize: 15,
                      }}
                    >
                      ₪{ChoosingProduct?.priceInsteadOf}
                    </a>
                  </>
                </>
              )}
            </a>
          </div>
          <ul
            style={{
              backgroundColor: "white",
              padding: "0",
              margin: "0",
              width: "100%",
              //maxHeight: isOpen ? "150px" : "0", // Set max height to limit the size of dropdown
              overflowY: "auto", // Enable vertical scrolling when content overflows
              //opacity: isOpen ? "1" : "0", // Fade-in/out effect
              maxHeight: 150,
              marginBottom: 20,
              // productDropDowns1.length > 1
              //   ? "1px solid #e4e4e7"
              //   : "1px solid #18181b",
            }}
          >
            {MobileOpenDrawerOBJ.length > 1 ? (
              <>
                {MobileOpenDrawerOBJ.map((product) => (
                  <li
                    key={product.id}
                    style={{
                      padding: "10px 20px",
                      cursor: "pointer",
                      border:
                        ChoosingProduct?.id === product?.id
                          ? "1px solid #18181b"
                          : "1px solid #e4e4e7",
                    }}
                    onClick={() => {
                      setChoosingProduct(product);
                    }}
                    // onClick={() => {
                    //   handleOptionClick(product.dropDown);
                    //   setTheDiscount(product.discount);
                    //   setPrice(product.price); // Example: Add 20 to the price
                    //   setThedeal(product.theDeal);
                    //   setDiscount(
                    //     product.price -
                    //       (product.price * product.discount) / 100
                    //   );
                    //   setIdOfProduct(product.id);
                    // }}
                  >
                    {product.dropDown}
                  </li>
                ))}
              </>
            ) : (
              <></>
            )}
          </ul>
          <button
            style={{
              backgroundColor: "#27272a",
              color: "#fff",
              border: "none",
              padding: "10px 20px",
              cursor: "pointer",
              fontSize: "16px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={() => {
              user === null
                ? setBuyNotLogin(true)
                : BuyButton(ChoosingProduct?.id);

              //CreateProduct();
            }}
          >
            {LoadingClickBuyButtonAllApp ? (
              <>
                <Lottie
                  style={{ height: 30, width: 30 }}
                  animationData={LottifileLoading}
                />
              </>
            ) : (
              <>{t("profile.Buy")}</>
            )}
          </button>
        </div>
      </Drawer>
      {/* <div>
        <h2>Child Component</h2>
        <p>Data from parent: {MobileOpenDrawerOBJ?.name}</p>
        <button onClick={CloseMobileDrawerFunc}>Run Function in Child</button>
      </div> */}
    </div>
  );
}
